import { render } from "./AddCustomSetting.vue?vue&type=template&id=06924fd4&scoped=true&ts=true"
import script from "./AddCustomSetting.vue?vue&type=script&lang=ts"
export * from "./AddCustomSetting.vue?vue&type=script&lang=ts"

import "./AddCustomSetting.vue?vue&type=style&index=0&id=06924fd4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06924fd4"]])

export default __exports__